import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 

// import '../index.css'
import OurOfferings from "../components/whychoosedroneplanet/OurOfferings";
import DroneMarketplace from "../components/whychoosedroneplanet/DroneMarketplace";
import Hero from "../components/whychoosedroneplanet/Banner";

import VendorOnboarding from "../components/whychoosedroneplanet/VendorOnboarding";
import DroneJobs from "../components/whychoosedroneplanet/DroneJobs";
import DroneTraining from "../components/whychoosedroneplanet/DroneTraining";
import DroneService from "../components/whychoosedroneplanet/DroneService";
import { WhyChooseDronePlanet } from "../components/whychoosedroneplanet/WhyChooseDronePlanet";

// import { BlogResources } from '../components/WhyChooseDroneplanet/BlogResources';

import NewsletterSubscription from "../components/whychoosedroneplanet/NewsletterSubscription";
import { BlogResources } from "../components/whychoosedroneplanet/BlogResources";
import { Header, Footer } from "../shared";

const WhyDrone = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: Smooth scrolling animation
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <Hero />
      <OurOfferings />
      <DroneMarketplace />
      <VendorOnboarding />
      <DroneJobs />
      <DroneTraining />
      <DroneService />

      <WhyChooseDronePlanet />
      <BlogResources />
      <NewsletterSubscription />
      <Footer />
    </div>
  );
};

export default WhyDrone;
